import Flex from "@/components/Flex";
import Text from "@/components/Text";
import {
  CHART_COLORS,
  CHART_TYPOGRAPHY,
} from "@/components/app/provider/patient/chart";

export type AttendanceTallyTileProps = {
  value: number;
  caption: string;
  color?: string;
  bgColor?: string;
};

const VALUE_FONT_SIZE = "15px";
const CAPTION_FONT_SIZE = "9px";
const TILE_HEIGHT = 56;
const TILE_RADIUS = "6px";

/**
 * One attendance count as a tinted tile. The tiles share the rail's width
 * equally, and the caption never wraps.
 *
 * @author Rajkumar Rathod
 */
const AttendanceTallyTile = ({
  value,
  caption,
  color,
  bgColor,
}: AttendanceTallyTileProps) => (
  <Flex
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    sx={{
      flex: 1,
      minWidth: 0,
      height: TILE_HEIGHT,
      px: 0.25,
      borderRadius: TILE_RADIUS,
      backgroundColor: bgColor ?? CHART_COLORS.surfaceSubtle,
    }}
  >
    <Text
      size={VALUE_FONT_SIZE}
      fontWeight={CHART_TYPOGRAPHY.weight.semiBold}
      c={color ?? CHART_COLORS.textDarker}
    >
      {value}
    </Text>
    <Text
      size={CAPTION_FONT_SIZE}
      c={color ?? CHART_COLORS.textMutedGrey}
      noWrap
    >
      {caption}
    </Text>
  </Flex>
);

export default AttendanceTallyTile;
